import React, { useState, useEffect } from "react";
import classNames from "classnames";

const Modal = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleKeyPress = ({ keyCode }) => {
    if (keyCode === 27) {
      closeModal();
    }
  };

  useEffect(() => {
    document.addEventListener("keyup", handleKeyPress);

    return () => {
      document.body.classList.remove("overflow-hidden");
      document.removeEventListener("keypress", handleKeyPress);
    };
  });

  const handleOpen = () => {
    document.body.classList.add("overflow-hidden");
    setIsOpen(true);
  };

  const handleClose = (event) => {
    if (event.target.id !== "modalBackground") {
      return;
    }

    closeModal();
  };

  const closeModal = () => {
    document.body.classList.remove("overflow-hidden");
    setIsOpen(false);
  };

  return (
    <div
      className={classNames(
        "transition-[background-color]",
        { "fixed inset-0 bg-[#000000B3] z-50": isOpen },
        { "bg-000": !isOpen }
      )}
      onClick={handleClose}
      id="modalBackground"
    >
      <div
        className={classNames(
          "fixed inset-x-[10vw] inset-y-[10vh] bg-white border-8 rounded-lg border-blue-200 transition-transform z-10 overflow-hidden",
          { "translate-x-0 overflow-y-scroll": isOpen },
          { "translate-x-[80vw] cursor-pointer": !isOpen }
        )}
        onClick={handleOpen}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
